import { useCallback, useEffect, useState } from "react";

/**
 * Layout state for floating filter panel inside modals / embedded shells.
 * Panel overlays content (fixed position); main content is not resized.
 */
export function useEmbeddedFilterLayout() {
  const [isOpen, setIsOpen] = useState(false);
  const [focusedFieldId, setFocusedFieldId] = useState(null);

  const open = useCallback((fieldId = null) => {
    setIsOpen(true);
    if (fieldId) setFocusedFieldId(fieldId);
  }, []);
  const close = useCallback(() => {
    setIsOpen(false);
    setFocusedFieldId(null);
  }, []);
  const toggle = useCallback(() => {
    setIsOpen((v) => {
      if (v) setFocusedFieldId(null);
      return !v;
    });
  }, []);
  const focusField = useCallback((fieldId) => {
    setFocusedFieldId(fieldId);
    setIsOpen(true);
  }, []);
  const clearFocus = useCallback(() => setFocusedFieldId(null), []);

  useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") close();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [isOpen, close]);

  return {
    isOpen,
    focusedFieldId,
    open,
    close,
    toggle,
    focusField,
    clearFocus,
  };
}

export default useEmbeddedFilterLayout;
